// extracted by mini-css-extract-plugin
module.exports = {"container":"DS8nOVVNGpqLSrV8r_qdL","tableOfContents":"vSLXOhijUBW2lqbEatidt","name":"_1E5VDK1crc34afs13bTeWe","type":"_2dNxwtTrDJ8pTyjaJgNSO0"};